import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import Input from 'components/FormElements/Input'
import { Button, Modal, BUTTON_LAYOUTS } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// views
import { Container, Header, ButtonsContainer } from './views'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'

const EditPrefixModal: React.FC = () => {
  const { updateRisk } = React.useContext(RiskAPIContext)

  const {
    hideModal,
    modalData: { isOpen = false, postfix }
  } = useModalData({ modalType: Modals.RISK_EDIT_PREFIX_MODAL })

  const [value, setValue] = React.useState('')

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  const onSaveClick = () => {
    if (!value) {
      return
    }

    updateRisk({ customerUniqueIdPostfix: parseInt(value, 10) })

    hideModal()
  }

  React.useEffect(() => {
    if (!value) {
      setValue(postfix)
    }
  }, [postfix])

  return (
    <Modal isOpen={isOpen} width='xs' hideModal={hideModal}>
      <Container>
        <Header>Edit Risk Uniq ID</Header>
        <Input debounced fullWidth name='name' type='number' value={value} isError={!value} onChange={onChange} />
        <ButtonsContainer>
          <Button shadowLess type='button' onClick={onSaveClick} layout={BUTTON_LAYOUTS.PURPLE}>
            Save
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
            Cancel
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

export default EditPrefixModal
